import { FullScreenLoading } from '@backrs_ui/common-ui';

import { useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';

import { ProsperPage } from './ProsperPage';
import { useAgentContext } from './ProsperPageContainer.agentContext';

export const ProsperPageContainer = () => {
  const contentCompetencies = useAppSelector(
    (state) => state.contentCompetency.contentCompetencies,
  );

  useAgentContext(contentCompetencies ?? []);

  const isLoading = !contentCompetencies;

  if (isLoading) {
    return <FullScreenLoading />;
  }

  return <ProsperPage contentCompetencies={contentCompetencies} />;
};
